// 导入视频文件
import video1 from '../assetsV2/featured/aotu2.mp4';
import video2 from '../assetsV2/featured/auto1.mp4';

// 导入图片文件
import viewWhite from '../assetsV2/featured/view_white.png';
import likeWhite from '../assetsV2/featured/like_white.png';
import likeIconSvg from '../assetsV2/featured/like-icon.svg';
import viewIconSvg from '../assetsV2/featured/view-icon.svg';

// 新增默认导出
const featuredAssets = [
  video1,
  video2,
  viewWhite,
  likeWhite,
  likeIconSvg,
  viewIconSvg
];

export default featuredAssets;
